import Counter from "./counter/counter.component";

export {
    Counter
}